import inputsConfig from "../inputConfig";

export default {
  accordion: false,
  items: [
    {
      name: "Select Company",
      required: true,
      fields: inputsConfig.company_id,
    },
    {
      name: "New Team Name",
      required: true,
      fields: inputsConfig.team_name,
    },
    {
      name: "Default Challenger Type",
      required: false,
      fields: inputsConfig.default_challenger_type,
    },
    {
      name: "Default Challenger Role",
      required: false,
      fields: inputsConfig.default_challenger_role,
    },
  ],
};
